import React from "react";
import styles from "../../../assets/css/modules/containers/side-swipe.css";

export default function(props) {
  return <div className={styles.sideswipe}>{props.children}</div>;
}
